import React, { Component } from 'react';
import Modal from "./Modal.js";
import ParadigmaTable from "../../components/ParadigmaTable/";
import api from "../../api";

class Clientes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Tipo Documento",
                    id: "tipoDocumento",
                    show: false,
                    private: true
                },
                {
                    Header: "Documento",
                    id: "nroDocumento",
                    className: "text-center",
                    accessor: d => `${d.tipoDocumento.abreviatura} ${d.nroDocumento}`,
                    width: 150,
                    show: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre_completo",
                    accessor: "nombre_completo",
                    width: 250,
                    show: true,
                },
                {
                    Header: "Dirección",
                    id: "lista_direcciones",
                    accessor: "lista_direcciones",
                    show: true,
                },
                {
                    Header: "Teléfono",
                    id: "lista_telefonos",
                    accessor: "lista_telefonos",
                    show: true,
                },
                {
                    Header: "Mails",
                    id: "lista_emails",
                    accessor: "lista_emails",
                    show: true,
                },
                {
                    Header: "Estado civil",
                    id: "estadoCivil",
                    className: "text-center",
                    accessor: d => (d.estadoCivil) ? (`${d.estadoCivil.nombre}`) : (''),
                    width: 150,
                    show: false,
                    private: true,
                },
                {
                    Header: "Estado civil",
                    id: "estadoCivil__nombre",
                    className: "text-center",
                    accessor: d => (d.estadoCivil) ? (`${d.estadoCivil.nombre}`) : (''),
                    width: 150,
                    show: true,
                },
                {
                    Header: "Nacionalidad",
                    id: "nacionalidad",
                    className: "text-center",
                    accessor: d => (d.nacionalidad) ? (`${d.nacionalidad.nombre}`) : (''),
                    width: 150,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nacionalidad",
                    id: "nacionalidad__nombre",
                    className: "text-center",
                    accessor: d => (d.nacionalidad) ? (`${d.nacionalidad.nombre}`) : (''),
                    width: 150,
                    show: true,
                },
            ]
        };
    }

    render() {
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: props => <Modal {...props} action="CREATE"/>,
                        permission: 'clientes_new',
                    },
                    {
                        edit: true,
                        component: props => <Modal {...props} action="EDIT" />,
                        permission: 'clientes_edit',
                    },
                    {
                        detail: true,
                        component: props => <Modal {...props} action="DETAIL" />,
                        permission: 'clientes_detail',
                    },
                    {
                        edit: true,
                        component: props => <Modal {...props} action="DELETE" />,
                        permission: 'clientes_delete',
                    }
                ]}
                depth={1}
                apiUrl={api.clientes.clientes}
                columns={this.state.columns}
                exportUrl={api.clientes.clientes}
                title={"Clientes"}
            />
        );
    }
}

export default Clientes;


// WEBPACK FOOTER //
// ./src/views/Clientes/Clientes.js